export const ROUND_DURATION = 180
export const RESULTS_DURATION = 10
export const QUEUE_COUNTDOWN_DURATION = 60
export const ALLOW_PLAYER_FLY = false
export const MIN_QUEUE_PLAYERS = 2
